export default {
  defaults: {
    debug: true,
    contentful_api: {
      space: 'db4li81caeza',
      domain_entry_id: '1y7sUgFFYw8yA4ACcGsoau',
      // website_entry_id: '3EB5DLgEVWK6Aaii4kQAMm',
      access_token: 'ed6d1df01525737edb52b9e3f44e1d1bf58a22d90ae08fad602e89f991c896c7',
      content_types: 'https://cdn.contentful.com/spaces/db4li81caeza/content_types',
      entries: 'https://cdn.contentful.com/spaces/db4li81caeza/entries/',
      assets: 'https://cdn.contentful.com/spaces/db4li81caeza/assets/',
      limit: 10
    },
    socket_api: {
      async: true,
      host: '',
      token: '',
      tokenName: 'token'
    },
    socket: {
      async: true,
      host: '',
      token: '',
      tokenName: 'token'
    },
    mcAction: 'https://digigurus.us16.list-manage.com/subscribe/post?u=09283e07454e068bd65340edd&amp;id=3d6aaf4c34'
  }
}



// WEBPACK FOOTER //
// ./src/config/global.js